import getDisplayName from "./utils/getDisplayName";
export function wrapDisplayName(name) {
  return {
    staticCallback: function staticCallback(componentClass, target) {
      componentClass["displayName"] = name + "(" + getDisplayName(target) + ")";
    }
  };
}
export default wrapDisplayName;